import React from "react";
import { AssetIcon } from "./AssetIcon";
import { TeamAccess } from "target_wasm";

interface TeamLabelProps {
  team: TeamAccess;
}

export const TeamLabel: React.FC<TeamLabelProps> = ({ team }) => {
  const details = team.team_details_js();
  return (
    <>
      <AssetIcon
        size="sm"
        color={details.team_color_js()}
        asset={details.team_asset_js()}
      />
      <span className="truncate">{details.team_name_js()}</span>
    </>
  );
};

export default TeamLabel;
